function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1429",
  "data-name": "Group 1429",
  transform: "translate(-1011 -795)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_591",
  "data-name": "Rectangle 591",
  width: 18,
  height: 2,
  rx: 1,
  transform: "translate(1019 796)",
  fill: "#2294d2"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_595",
  "data-name": "Rectangle 595",
  width: 18,
  height: 2,
  rx: 1,
  transform: "translate(1019 803)",
  fill: "#2294d2"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_596",
  "data-name": "Rectangle 596",
  width: 18,
  height: 2,
  rx: 1,
  transform: "translate(1019 810)",
  fill: "#2294d2"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_71",
  "data-name": "Ellipse 71",
  cx: 2,
  cy: 2,
  r: 2,
  transform: "translate(1011 795)",
  fill: "#2294d2"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_72",
  "data-name": "Ellipse 72",
  cx: 2,
  cy: 2,
  r: 2,
  transform: "translate(1011 802)",
  fill: "#2294d2"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_73",
  "data-name": "Ellipse 73",
  cx: 2,
  cy: 2,
  r: 2,
  transform: "translate(1011 809)",
  fill: "#2294d2"
}));

var SvgListView = function SvgListView(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 18,
    viewBox: "0 0 26 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgListView, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/list-view.39cd5c5b.svg";
export { ForwardRef as ReactComponent };